import { BaseRouteService } from "./BaseRouteService";

export class PuzzleService extends BaseRouteService {
    public async solvePuzzle(code: string): Promise<{ solved: boolean }> {
        try {
            // Uses the inherited getJsonApi method from BaseRouteService
            return await this.getJsonApi<{ solved: boolean }>(`puzzle/solve-puzzle/${code}`);
        }
        catch {
            throw new Error("Failed to solve puzzle");
        }
    }
}
